import React, { useState } from 'react';
import styles from './ReverseOrderManagement.module.scss';
import { Button, Container } from 'reactstrap';
import { utils, writeFile } from 'xlsx';
import FilterInTable from '../../../../Manage/FilterInTable';
import DataTable from 'react-data-table-component';
import { ChevronDown } from 'react-feather';
import FilterTabsCommon from '../../../../../components/common/FilterTabsCommon/FilterTabsCommon';

const data = [
    {
        id: 1,
        returnId: '367658',
        orderId: '367658',
        type: 'Customer return',
        date: '11/07/2024',
        amount: '$40',
        warehouse: 'Warehouse 1',
        status: 'Processing',
    },
    {
        id: 2,
        returnId: '367658',
        orderId: '367658',
        type: 'Customer return',
        date: '11/07/2024',
        amount: '$40',
        warehouse: 'Warehouse 1',
        status: 'Processing',
    },
    {
        id: 3,
        returnId: '367658',
        orderId: '367658',
        type: 'Customer return',
        date: '11/07/2024',
        amount: '$40',
        warehouse: 'Warehouse 1',
        status: 'Processing',
    },
    {
        id: 4,
        returnId: '367658',
        orderId: '367658',
        type: 'Customer return',
        date: '11/07/2024',
        amount: '$40',
        warehouse: 'Warehouse 1',
        status: 'Processing',
    },
];

const columns = [
    {
        name: 'Return ID',
        selector: (row) => row.returnId,
        sortable: true,
    },
    {
        name: 'Order ID',
        selector: (row) => row.orderId,
        sortable: true,
    },
    {
        name: 'Type',
        selector: (row) => row.type,
        sortable: true,
    },
    {
        name: 'Created Date',
        selector: (row) => row.date,
        sortable: true,
    },
    {
        name: 'Total Amount',
        selector: (row) => row.amount,
        sortable: true,
    },
    {
        name: 'Warehouse',
        selector: (row) => row.warehouse,
        sortable: true,
    },
    {
        name: 'Status',
        selector: (row) => row.status,
        sortable: true,
    },
    {
        name: 'Action',
    },
];

const customStyles = {
    table: {
        style: {
            borderLeft: '1px solid #D9D9D9',
            borderTop: '1px solid #D9D9D9',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
            color: '#1A2425',
            fontSize: '15px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            borderRight: '1px solid #D9D9D9',

            div: {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
            }
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
            borderRight: '1px solid #D9D9D9',

            div: {
                whiteSpace: 'normal !important',
                wordWrap: 'break-word',
            }
        },
    },
};

const fiterTabs = [
    { id: 'all', label: 'All' },
    { id: 'customerReturn', label: 'Customer Return' },
    { id: 'failedDelivery', label: 'Failed Delivery' },
];

const ReverseOrderManagement = () => {

    const [activeCategory, setActiveCategory] = useState("all");

    const handlePrint = () => {
        window.print();
    };

    const handleExportExcel = () => {
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Products');
        writeFile(workbook, 'ManagePlatformProducts.xlsx');
    };

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Reverse Order Management</h4>

            <div className={styles.filterContainer}>
                <FilterTabsCommon
                    tabs={fiterTabs}
                    activeTab={activeCategory}
                    setActiveTab={setActiveCategory}
                />
            </div>

            <Container fluid className={styles.reverseOrderContainer}>

                <FilterInTable componentName={"Order Management"} />

                <Container fluid className={styles.totalOrderBtnsWrapper}>
                    <div className={styles.totalOrdersContainer}>
                        <span>Total Orders: 300</span>
                    </div>
                    <div className={styles.btnsContainer}>
                        <Button type="button" onClick={handlePrint}>
                            Print
                        </Button>
                        <Button type="button" onClick={handleExportExcel}>
                            Export
                        </Button>
                    </div>
                </Container>

                <div className={styles.reverseOrderTable}>
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        customStyles={customStyles}
                        sortIcon={<ChevronDown size={10} />}
                    />
                </div>
            </Container>
        </div>
    )
}

export default ReverseOrderManagement;